import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

const UPDATE_TIME_ZONE = '/v1/members/account/timezone';

export interface UpdateTimeZoneResponse {}
export interface UpdateTimeZoneBody {
  timeZone: string;
}
export const updateTimeZoneStatus = ({ timeZone }: UpdateTimeZoneBody) => {
  return httpClient.put<UpdateTimeZoneResponse>(UPDATE_TIME_ZONE, {
    timezone: timeZone,
  });
};

export const useUpdateTimeZoneStatus = (
  params?: UseMutationOptions<
    AxiosResponse<UpdateTimeZoneResponse>,
    AxiosError<any>,
    UpdateTimeZoneBody
  >,
) => {
  return useMutation<
    AxiosResponse<UpdateTimeZoneResponse>,
    AxiosError<any>,
    UpdateTimeZoneBody
  >(updateTimeZoneStatus, params);
};
